import type { GameMeta } from "@kit/meta";

export const meta: GameMeta = {
  id: "kosu",
  name: "Harf Koşusu",
  tagline: "Üç şeritte koş, kütükten zıpla, kayadan kaç; resmin adını harf harf topla.",
  inspiredBy: "3D lane runner (Subway Surfers / Temple Run)",
  secondLayer: "Letter gates spell the name of a picture that sharpens as you write it.",
  accent: "#2a9d8f",
  status: "lab",
};
